module.exports = __webpack_public_path__ + "static/media/america-santos.d7e949a2.mp4";